import { render, staticRenderFns } from "./answerExam.vue?vue&type=template&id=d6f4106e"
import script from "./answerExam.vue?vue&type=script&lang=js"
export * from "./answerExam.vue?vue&type=script&lang=js"
import style0 from "./answerExam.vue?vue&type=style&index=0&id=d6f4106e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports